import { FormControlLabel, Radio } from "@material-ui/core";
import "./index.css";

const MyRadio = ({
  value = true,
  setValue = () => {},
  title = "",
  disabled = false,
}) => {
  return (
        <FormControlLabel
          value="end"
          control={<Radio style={{padding:'2px'}} disabled={disabled} checked={value} onChange={setValue} color="primary" />}
          label={title}
          labelPlacement="end"
        />
      
  );
};

export default MyRadio;
